import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardHeader, CardContent, Typography, Grid, Hidden } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { actionGetExtraItem, actionIncreaseQuantity } from 'actions';
import { genfunction } from '../../helpers';
import ReactHtmlParser from 'react-html-parser';
import { NumberSpinner } from '../InputControls'
import ErrorHandling from '../ErrorHandling/ErrorHandling';
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from '@material-ui/core/Tooltip';

const { OtherExtraItemHeader, ApplyCostRatesOnManageMyBooking } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    hidetopheader: {
        display: 'none'
    },
    cardcontent: {
        "&:last-child": {
            paddingBottom: 5
        }
    }
}));

const ExtraItemsProducts = (props) => {
    const classes = useStyles();
    const [errorMsg, seterrorMsg] = useState("");
    const dispatch = useDispatch()
    const reducerAppLoader = useSelector(state => state.reducerAppLoader.loading);


    const changeQuantityHandler = (reference, quantity) => {

        if (props.allowQuantityChange === false) {
            seterrorMsg("Please remove coupon code to make futher changes.");
            return;
        }

        if (cartEvents && cartEvents.length > 0) {
            if (cartEvents[0].TourProducts.filter(x => x.AffectsCapacity).length > 0) {
                actionIncreaseQuantity(dispatch, reference.TourProductID, quantity, true, reference.MinimumTickets, reference.MaximumTickets);

                if (bkngType.AddChaperoneTickets && bkngType.ShowTourProductsBasedOnGroupSize)
                    calculateChaperoneTickets();

                return;
            }
        }

        actionIncreaseQuantity(dispatch, reference.TourProductID, quantity, false, reference.MinimumTickets, reference.MaximumTickets);

        if (bkngType.AddChaperoneTickets && bkngType.ShowTourProductsBasedOnGroupSize)
            calculateChaperoneTickets();
    }

    const apiData = useSelector(state => state.reducerExtraItems.extraItem);
    const cartEvents = useSelector(state => state.reducerShopCart.events);
    const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
    const bkngType = bookingTypes && bookingTypes.length > 0 ? bookingTypes.filter(x => x.BookingTypeID == props.bookingtypeID)[0] : null;
    const shopcartreducer = useSelector(state => state.reducerShopCart);

    const calculateChaperoneTickets = () => {

        let TotalTickets = 0;

        if (apiData && apiData.TourProducts.filter(p => p.AffectsCapacity && p.TourProductID != bkngType.ChaperoneTourProductID).length > 0) {
            TotalTickets = apiData.TourProducts.filter(p => p.AffectsCapacity && p.TourProductID != bkngType.ChaperoneTourProductID
            ).reduce((a, b) => {
                let aqty = a.Quantity === undefined ? 0 : a.Quantity;
                let bqty = (b === undefined || b.Quantity === undefined) ? 0 : b.Quantity;
                let newobj = { Quantity: aqty + bqty }
                return newobj;
            }).Quantity;
        }

        let noOfChaperoneTickets =
            (TotalTickets !== 0 && bkngType.NumberOfTicketsRequiredPerChaperone !== 0) ? TotalTickets / bkngType.NumberOfTicketsRequiredPerChaperone : 0;

        noOfChaperoneTickets = noOfChaperoneTickets >= 1 ? noOfChaperoneTickets : 0;
        noOfChaperoneTickets = bkngType.RoundChaperoneTicketsUp ? Math.ceil(noOfChaperoneTickets) : Math.floor(noOfChaperoneTickets)

        actionIncreaseQuantity(dispatch, bkngType.ChaperoneTourProductID, noOfChaperoneTickets, false);

    }

    const CalculateMaxTickets = (TourProductID) => {
        let shopCartConsumed = 0;

        if (!props.isEditEvent)
            if (cartEvents && cartEvents.length > 0) {
                let cartTourEvent = cartEvents.find(x => x.TourEventID == apiData.TourEventID);
                if (cartTourEvent && cartTourEvent.TourProducts.length > 0) {
                    shopCartConsumed = cartTourEvent.TourProducts.filter(p => p.AffectsCapacity).reduce((a, b) => {
                        let aqty = a.Quantity === undefined ? 0 : a.Quantity;
                        let bqty = b.Quantity === undefined ? 0 : b.Quantity;
                        let newobj = { Quantity: aqty + bqty }
                        return newobj;
                    }).Quantity;
                }
            }

        let consumedQty = 0;
        if (apiData.TourProducts.filter(p => p.TourProductID != TourProductID && p.AffectsCapacity && p.TourProductID != bkngType.ChaperoneTourProductID).length > 0) {
            consumedQty = apiData.TourProducts.filter(p => p.TourProductID != TourProductID && p.AffectsCapacity
                && p.TourProductID != bkngType.ChaperoneTourProductID
            ).reduce((a, b) => {
                let aqty = a.Quantity === undefined ? 0 : a.Quantity;
                let bqty = (b === undefined || b.Quantity === undefined) ? 0 : b.Quantity;
                let newobj = { Quantity: aqty + bqty }
                return newobj;
            }).Quantity;
        }

        let MaximumTickets = genfunction.IsNotNullOrEmptyOrUndefined(props.groupSize) ? props.groupSize.toLowerCase().split(" to ")[1] : bkngType.MaximumTickets;

        return bkngType !== undefined ? MaximumTickets - consumedQty - shopCartConsumed : 0;
    }

    const replaceEscapeCharacters = (item) => {
        var itemValue = item.split("\\r\\n").join("<br />");
        itemValue = itemValue.split("\\").join("");
        return itemValue;
    }

    useEffect(() => {

        if (props.isEditEvent && reducerAppLoader === false)
            reloadQuantity();

    }, [reducerAppLoader]);

    useEffect(() => {
        if (props.isMMB)
            actionGetExtraItem(dispatch, props.tourEventId, props.ismembershipapplied && ApplyCostRatesOnManageMyBooking, props.membercostrate, props.isIDME, props.isIDMECostrate, props.organizationCostRate);

    }, [])

    const reloadQuantity = () => {

        if (cartEvents && cartEvents.length > 0 && cartEvents.find(x => x.TourEventID === props.tourEventId)) {
            let cartTourEvent = cartEvents.find(x => x.TourEventID === props.tourEventId);

            if (apiData.hasOwnProperty("TourProducts")) {

                apiData.TourProducts.map(p => {
                    if (cartTourEvent.TourProducts.filter(x => x.TourProductID === p.TourProductID).length > 0) {
                        let pQty = cartTourEvent.TourProducts.filter(x => x.TourProductID === p.TourProductID)[0].Quantity;
                        actionIncreaseQuantity(dispatch, p.TourProductID, pQty, true);

                    }

                    return p
                });
            }

        }
    }

    const errorcancelhandle = () => {
        seterrorMsg("");
    }


    return (
        <div >
            <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />

            <Card style={{ borderRadius: "0", width: "100%" }}>
                <CardHeader className={props.hidetopheading ? classes.tourheaderbox + ' ' + classes.hidetopheader : classes.tourheaderbox}
                    style={{ paddingLeft: "25px" }}
                    title={apiData.hasOwnProperty("EventStartDateTime") ? ShowStartAndEndTime(bkngType, apiData) : null}
                    titleTypographyProps={{ color: "inherit" }}
                />

                <CardContent className={classes.cardcontent}>

                    <Grid style={{ padding: "10px" }} container alignItems="center" item xs={12} ms={12} lg={12}>
                        {apiData.hasOwnProperty("TourProducts") ?
                            apiData.TourProducts.map((product, i) => {

                                return product.AffectsCapacity && product.AvailableOnline && product.TourProductID !== bkngType.ChaperoneTourProductID &&
                                    (genfunction.IsNotNullOrEmptyOrUndefined(props.groupSize) ? product.LimitDisplayOnGroupSize && product.GroupSize === props.groupSize : true)
                                    && product.PriceMatrix !== undefined && product.PriceMatrix.length > 0 ?

                                    <Grid style={{ padding: "5px" }} container alignItems="center" item xs={12} ms={12} lg={12} key={product.TourProductID}>
                                        <Grid item xs={2} ms={2} lg={2}>
                                            <Tooltip title={ReactHtmlParser(replaceEscapeCharacters(product.Information))} enterTouchDelay={0} leaveTouchDelay={3000}>
                                                <InfoIcon arrow="true" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={6} ms={6} lg={6}>
                                            <Hidden smDown>
                                                <Typography variant="h4">{product.TourProductName + ' ' + genfunction.ccyFormat(product.PriceMatrix[0].Price)}</Typography>
                                            </Hidden>

                                            <Hidden xsDown mdUp>
                                                <Typography variant="h5">{product.TourProductName + ' ' + genfunction.ccyFormat(product.PriceMatrix[0].Price)}</Typography>
                                            </Hidden>

                                            <Hidden smUp>
                                                <Typography variant="h6">{product.TourProductName + ' ' + genfunction.ccyFormat(product.PriceMatrix[0].Price)}</Typography>
                                            </Hidden>

                                        </Grid>

                                        <Grid item xs={4} ms={4} lg={4}>
                                            <NumberSpinner
                                                refrence={{
                                                    TourProductID: product.TourProductID,
                                                    MaximumTickets: bkngType !== undefined ? bkngType.MaximumTickets : 0,
                                                    MinimumTickets: bkngType !== undefined ? bkngType.MinimumTickets : 0
                                                }}
                                                value={product.Quantity === undefined ? 0 : product.Quantity}
                                                minValue={0}
                                                maxValue={CalculateMaxTickets(product.TourProductID)}
                                                steps={1}
                                                changeHandler={changeQuantityHandler}
                                            ></NumberSpinner>
                                        </Grid>
                                    </Grid>
                                    : null
                            }) : null}

                    </Grid>

                    {apiData.hasOwnProperty("TourProducts") ?
                        apiData.TourProducts.filter(x => x.AffectsCapacity == false && x.AvailableOnline == true && x.PriceMatrix !== undefined && x.PriceMatrix.length > 0
                            && x.TourProductID !== bkngType.ChaperoneTourProductID).length > 0 ?

                            <Typography className={classes.tourheaderbox} variant="subtitle1" style={{ margin: "0 -15px 0 -15px", padding: "5px 0 5px 25px" }}>{OtherExtraItemHeader}</Typography>
                            : null
                        : null}

                    <Grid style={{ padding: "10px" }} container alignItems="center" item xs={12} ms={12} lg={12}>
                        {apiData.hasOwnProperty("TourProducts") ?
                            apiData.TourProducts.map(product => {

                                return product.AffectsCapacity == false && product.AvailableOnline && product.PriceMatrix !== undefined && product.PriceMatrix.length > 0
                                    && product.TourProductID !== bkngType.ChaperoneTourProductID ?

                                    <Grid style={{ padding: "5px" }} container alignItems="center" item xs={12} ms={12} lg={12} key={product.TourProductID}>

                                        <Grid item xs={2} ms={2} lg={2}>
                                            <Tooltip title={ReactHtmlParser(replaceEscapeCharacters(product.Information))} enterTouchDelay={0} leaveTouchDelay={3000}>
                                                <InfoIcon arrow="true" color="primary" />
                                            </Tooltip>
                                        </Grid>

                                        <Grid item xs={6} ms={6} lg={6}>
                                            <Hidden smDown>
                                                <Typography variant="h4">{product.TourProductName + ' ' + genfunction.ccyFormat(product.PriceMatrix[0].Price)}</Typography>
                                            </Hidden>

                                            <Hidden xsDown mdUp>
                                                <Typography variant="h5">{product.TourProductName + ' ' + genfunction.ccyFormat(product.PriceMatrix[0].Price)}</Typography>
                                            </Hidden>

                                            <Hidden smUp>
                                                <Typography variant="h6">{product.TourProductName + ' ' + genfunction.ccyFormat(product.PriceMatrix[0].Price)}</Typography>
                                            </Hidden>


                                        </Grid>

                                        <Grid item xs={4} ms={4} lg={4}>
                                            <NumberSpinner
                                                refrence={{
                                                    TourProductID: product.TourProductID,
                                                    MaximumTickets: bkngType !== undefined ? bkngType.MaximumTickets : 0,
                                                    MinimumTickets: bkngType !== undefined ? bkngType.MinimumTickets : 0
                                                }}
                                                value={product.Quantity === undefined ? 0 : product.Quantity}
                                                minValue={0} maxValue={999} steps={1}
                                                changeHandler={changeQuantityHandler}
                                            ></NumberSpinner>
                                        </Grid>
                                    </Grid>
                                    : null
                            }) : null}

                    </Grid>

                </CardContent>
            </Card>
        </div>
    );
}

export default ExtraItemsProducts;


function ShowStartAndEndTime(bkngType, apiData) {
    let time = "";

    if (bkngType) {

        if (bkngType.ShowStartTime) {
            time += genfunction.GetEventDateReceiptFormat(apiData.EventStartDateTime);
        }

        if (bkngType.ShowEndTime && !bkngType.ShowStartTime) {
            time += genfunction.GetEventDateReceiptFormat(apiData.EventStartDateTime);
        }

        if (bkngType.ShowEndTime && bkngType.ShowStartTime) {
            time += ' - ' + genfunction.AppendEndTime(apiData.EventEndDateTime);
        }

        if (!bkngType.ShowStartTime && !bkngType.ShowEndTime) {
            time += genfunction.GetEventDateReceiptFormatwithoutTime(apiData.EventStartDateTime);
        }
    }

    return time;
}

